export enum DynamoDBStreamEventName {
    INSERT = 'INSERT',
    MODIFY = 'MODIFY',
    REMOVE = 'REMOVE'
}
